<template>
  <b-row>
    <b-col sm="12">
        <div v-if="pieOptions.day === null" class="text-center" style="font-size: 1em; padding: 100px 0px 100px;">
          <b-badge>There's no statistics data</b-badge>
        </div>
        <vue-highcharts :options="pieOptions.day"></vue-highcharts>
    </b-col>
  </b-row>
</template>

<script>
import VueHighcharts from 'vue2-highcharts'
import * as initConfigChart from '@/views/components/charts/HighchartInit'

export default {
  name: 'visitorPieChart',
  components: {
    VueHighcharts
  },
  data () {
    return {
      apiPieStatsVisitor: window.AppConfig.apiUrl + 'visitorstats',
      apiUrlStatus: window.AppConfig.apiUrl + 'visitor-status',
      color: {
        'Assigned': {
          'color': '#ffc107'
        },
        'Accepted': {
          'color': '#17a2b8'
        },
        'In Progress': {
          'color': '#3f82b6'
        },
        'Completed': {
          'color': '#28a745'
        }
      },
      pieOptions: {
        day: null,
        week: null,
        month: null
      },
      visitorStatusList: []
    }
  },
  mounted () {
    this.getVisitorStats('day')
    // this.doAutoRefresh()
  },
  beforeDestroy () {
    clearInterval(this.refVisitorPie)
  },
  methods: {
    getVisitorStats (period) {
      let dataChart = [
        {
          name: 'Assigned',
          selected: false,
          sliced: false,
          y: 2
        },
        {
          name: 'Accepted',
          selected: false,
          sliced: false,
          y: 10
        },
        {
          name: 'In Progress',
          selected: false,
          sliced: false,
          y: 3
        },
        {
          name: 'Completed',
          selected: false,
          sliced: false,
          y: 12
        }
      ]
      let opt = initConfigChart.pieOptions
      opt.series = [{
        name: 'data',
        data: dataChart
      }]
      opt.colors = [this.color['Assigned'].color, this.color['Accepted'].color, this.color['In Progress'].color, this.color['Completed'].color]
      let self = this
      opt.plotOptions.pie.point = {
        events: {
          click: function (e) {
            self.redirectToPage(this.name)
            return false
          }
        }
      }
      this.pieOptions[period] = opt
    },

    redirectToPage () {
      this.$router.push({path: '/tickets'})
    },

    doAutoRefresh () {
      this.refVisitorPie = setInterval(() => {
        this.getVisitorStats('day')
      }, window.AppConfig.IntervalRefreshDataDashboard)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/index/visitorPieChart.vue